<!--  -->
<template>
    <div class='About_ISFAL'>
        <div class="title_box">
            <img src="../../assets/images/isfal/bj_03.jpg" alt="">
        </div>
        <div class="Certification_System">
            <div class="Certification_System_box">
                <div class="System_box_1">
                    <div class="System_box_1_left">
                        <p class="System_box_1_left_1 active" >Certification System</p>
                        <p class="System_box_1_left_1" @click="onOfficers">Certification Officers</p>
                        <p class="System_box_1_left_1" @click="onSearch">Certificate Search</p>
                    </div>
                    <div class="System_box_1_right">
                        <div class="System_box_1_right_1">
                            <div class="System_box_1_right_1_l" v-html="text"></div>
                            <div class="System_box_1_right_1_r">
                                <img src="../../assets/images/isfal/10036.jpg" alt="">
                            </div>
                        </div>
                        <div style="line-height: 24px;margin-top:25px;" v-html="text2"></div>
                    </div>
                </div>  
            </div>
        </div>
    </div>
</template>

<script>
    import "@/assets/css/About_ISFAL.less"
    export default {
        name: '',
        data() {
            //这里存放数据
            return {
                text:"<p><strong>PALF: &nbsp;</strong><strong>Professional Action Learning Facilitator</strong></p><p>&nbsp;</p><p><strong>Professional Action Learning Facilitator-Multiple Problem</strong></p><p>1.Complete the Multiple Problem PALF certification course</p><p>2.Submit an MP action learning reflective workbook</p><p>3.Complete at least 20 hours of practice</p><p>4.Submit &nbsp;Multi-problem facilitation workshop practice assignment and pass the evaluation</p><p>&nbsp;</p><p><strong>Professional Action Learning Facilitator-Single Problem</strong></p><p>1.Complete the Single problem PALF certification course</p><p>2.Submit an SP action learning reflective workbook</p><p>3.Complete at least 20 hours of practice</p><p>4.Submit &nbsp;Single-problem facilitation workshop practice assignment and pass the evaluation</p>",
                text2:"<p><strong>SALF:&nbsp;</strong><strong>Senior Action Learning Facilitator</strong></p><p>1. Achieve 2 certification: both PALF-MP certification and PALF-SP certification</p><p>2. Accumulated more than 60 hours</p><p>3. Submit facilitation workshop practice assignment and pass the evaluation</p><p>&nbsp;</p><p>&nbsp;</p><p><strong>MALF: &nbsp;</strong><strong>Master Action Learning Facilitator</strong></p><p>1. Complete the SALF certification</p><p>2. Complete the MALF certification course</p><p>3. Submit a practical case assignment of a single and multiple problem mixed subject project</p><p>4. Accumulated more than 100 hours</p><p>5. Publish one professional article &nbsp;in Action Learning Research and Practice.</p>"
            }
        },
        components: {},

        //方法集合
        methods: {
            onSystem(){
                this.$router.push('/Certification_System')
            },
            onOfficers(){
                this.$router.push('/Certification_Officers')
            },
            onSearch(){
                this.$router.push('/Certificate_Search')
            }
        },
        created() {

        },
        mounted() {

        }
    }
</script>
<style scoped>

</style>